<template>
  <div class="tab flex-center w100">
    <div
      class="tab-btn-group flex-row items-center space-between"
      style="width: 90%"
    >
      <img style="width: 10%;margin-bottom: 20px;" src="@/assets/btn/logo.png" alt="" />
      <div class="iphone-tab" @click="IphoneTabType = !IphoneTabType">
        <img style="width: 35px !important;" src="@/assets/btn/phone-tab.png" alt="">
      </div>
      <div v-if="IphoneTabType" @click="IphoneTabType = !IphoneTabType" class="fixed" style="background-color: #0303038c;width: 100%;height: 100%;top: 0;left: 0;"></div>
      <div v-if="IphoneTabType" class="fixed w100 f1eee6-bg flex-start flex-column growFromBottomAnimation " style="bottom: 0;left: 0;padding-top: 20px;padding-bottom: 20px;">
        <div style="width: 90%;padding-bottom: 50px;" class="flex-row items-center space-between m-btm-20 m-auto" @click="IphoneTabType = !IphoneTabType">
          <img style="width: 35% !important;" src="@/assets/btn/logo.png" alt="">
          <img style="width: 20px !important;" src="@/assets/208/close.png" alt="">
        </div>
        <div          
          v-for="(item, i) in tabList"
          @click="goPage(item.path)"
          style="height: 25px;margin: 10px auto;width: 50%;"
          :class="{ TabIndex: $route.path == item.path }"
          :key="i">{{ item.name }}</div>
      </div>
      <div class="tab-btn-group1 flex-row content-around" style="width: 80%">
        <div
          class="tab-btn lt1"
          v-for="(item, i) in tabList"
          @click="goPage(item.path)"
          :key="i"
          :class="{ TabIndex: $route.path == item.path }"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      IphoneTabType: false,
      tabList: [
        {
          path: "/",
          name: "HOME",
        },
        {
          path: "/location",
          name: "LOCATION",
        },
        {
          path: "/FACILITIES",
          name: "FACILITIES",
        },
        {
          path: "/INTERIOR",
          name: "INTERIOR",
        },
        {
          path: "/GALLERY",
          name: "GALLERY",
        },
        {
          path: "/BROCHURE",
          name: "EC-BROCHURE",
        },
        {
          path: "/CONTACT",
          name: "CONTACT US",
        },
        {
          path: "/DEVELOPERS",
          name: "ABOUT DEVELOPERS",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    goPage(pagePath) {
      this.IphoneTabType = false
      this.$router.push(pagePath).catch((err) => {});
    },
  },
};
</script>

<style lang="less">
.tab-btn-group1{
  display: flex;
}
.iphone-tab{
  display: none;
}



.tab {
  position: relative;
  z-index: 999;
  width: 100%;
  height: 165px;
  background-image: url("~@/assets/home/hd-bg.png");
  background-size: 100% 100%;
  .TabIndex::before{
  height: 3px !important;
  background-color: #575252 !important;
  }
  .tab-btn {
    color: #575252;
    // font-weight: 600;
    font-size: 14px;
    margin-bottom: 20px;
    cursor: pointer;
    height: 25px;
  }
  .tab-btn:nth-child(1) {
    margin-left: 25px !important;
  }
}



@media (max-width: 900px) {
  .tab-btn-group1{
  display: none !important;
  }
  .iphone-tab{
    display: flex;
  }
  .tab {
    background-image: url("~@/assets/btn/phoneTab.png") !important;
    .tab-btn-group {
      width: 90%;
      img{
        width: 45% !important;
      }
    }
  }
}




</style>






